
let _guid = null
export const getGuid = () => {
  return new Promise((resolve, reject) => {
    if (_guid) return resolve(_guid)

    if (window.browser && window.browser.app && window.browser.app.getBrowserParam) {
      window.browser.app.getBrowserParam(({
        guid
      }) => {
        _guid = guid
        return resolve(guid)
      }, (err) => {
        return reject(err);
      })
    } else {
      return resolve(null)
    }
  })
}

let _qbid = null
export const getQbid = () => {
  return new Promise((resolve, reject) => {
    if (_qbid) return resolve(_qbid)

    if (window.browser && window.browser.login && window.browser.login.getAccountInfo) {
      window.browser.login.getAccountInfo(accountInfo => {
        if (!accountInfo) return resolve(null)
        _qbid = accountInfo.qbid
        return resolve(accountInfo.qbid)
      }, (err) => {
        return reject(err);
      })
    } else {
      return resolve(null)
    }
  })
}